import service from '../../utils/service'
import config from "@/utils/global.js";
import axios from "@/http/axios";

/**
 *宋建国：2019/9/6 21:34
 *描述：导出excel接口
 *版本：1.0
 */
export const exportExcel = (data) => {
    console.log('exportExcel',data);
  let pvar = Object.assign({}, {
      hostUrl:  "",
      url: '/excel/exportExcel',
      method: 'POST',
      responseType: "blob"}, data);
      pvar["hostUrl"] = data.data.selfDate.url.split('/').splice(0,data.data.selfDate.url.split('/').length-2).toString().replace(/,/g,'/');
      // pvar["url"] = data.data.selfDate.url;
      console.log('exportExcelpvar',pvar);
  return axios(pvar);
}
export const newExportExcel = (data) => {
    data.data.pageBean.pageSize = 0;  // 此处为了控制导出全部数据
  let pvar = Object.assign({}, {
      hostUrl:  "",
    //   url: '/xyj-xd-main/r/excel/exportPage',
      url: '/excel/exportPage',
      method: 'POST',
      responseType: "blob"}, data);
    //   pvar["hostUrl"] = data.data.selfDate.hostUrl;
      pvar["hostUrl"] = data.data.selfDate.url.split('/').splice(0,data.data.selfDate.url.split('/').length-2).toString().replace(/,/g,'/');
      // pvar["url"] = data.data.selfDate.url;
      console.log(pvar);
  return axios(pvar);
}
/**
 *宋建国：2019/9/25 13:40
 *描述：根据类型获取单据号
 *版本：1.0
 */
export const createRuleNoByType = (data) =>{
  return axios({
    hostUrl: config.zuul,
    url: '/xyj-admin/r/billsRules/createRuleNoByType',
    method: 'get',
    params: data
  });
}
/**
 *宋建国：2019/9/25 13:44
 *描述：根据单据规则ID获取单据号
 *版本：1.0
 */
export const createRuleNo = (data) =>{
  return axios({
    hostUrl: config.zuul,
    url: '/xyj-admin/r/billsRules/createRuleNo',
    method: 'get',
    params: data
  });
}


/*基础模块*/
export const xyjPost = data => {
    return service.zwlService.post(data.url,data.data).then((res) => {
        return res.data
    }).catch((error) => {
        return error
    })
}
export const xyjGet = data => {
    return service.zwlService.get(data.url,{params:data.data}).then((res) => {
        return res.data
    }).catch((error) => {
        return error.response.data
    })
}
export const xyjDel = data => {
    return service.zwlService.delete(data.url,{params:data.data}).then((res) => {
        return res.data
    }).catch((error) => {
        return error.response.data
    })
}
/*公共支付模块*/
export const xyjPostzf = data => {
    return service.common.post(data.url,data.data).then((res) => {
        return res.data
    }).catch((error) => {
        return error.response.data
    })
}
export const xyjGetzf = data => {
    return service.common.get(data.url,{params:data.data}).then((res) => {
        return res.data
    }).catch((error) => {
        return error.response.data
    })
}
export const xyjDelzf = data => {
    return service.common.delete(data.url,{params:data.data}).then((res) => {
        return res.data
    }).catch((error) => {
        return error.response.data
    })
}


//支付设置、支付信息表、支付宝微信支付设置表
export const xyjPostPay = data => {
  return service.zfSetService.post(data.url,data.data).then((res) => {
    return res.data
  }).catch((error) => {
    return error.response.data
  })
}
export const xyjGetPay = data => {
  return service.zfSetService.get(data.url,{params:data.data}).then((res) => {
    return res.data
  }).catch((error) => {
    return error.response.data
  })
}
export const xyjDelPay = data => {
  return service.zfSetService.delete(data.url,{params:data.data}).then((res) => {
    return res.data
  }).catch((error) => {
    return error.response.data
  })
}




// WEBPACK FOOTER //
// ./src/http/moudules/common.js